import { OPENING_ACTIONS } from '../../constants/actionTypes';
const { COPIED_OPENING } = OPENING_ACTIONS;

const initialState = {
  status: 'idle', // idle, copied
};

function openingCopyButtonReducer(state = initialState, action) {
  switch (action.type) {
    case COPIED_OPENING:
      return { status: 'copied'};
    default:
      return state;
  }
}

export default openingCopyButtonReducer;



